// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"886c862a31ca0989bdee","293":"07dc1a5604c6141be8d9","518":"02b90148d5aa5d9ac511","779":"9506fad0e26a8e8b519b"}[chunkId] + ".js";
};